import { render, staticRenderFns } from "./records.vue?vue&type=template&id=5cd426b3&scoped=true"
import script from "./records.vue?vue&type=script&lang=js"
export * from "./records.vue?vue&type=script&lang=js"
import style0 from "./records.vue?vue&type=style&index=0&id=5cd426b3&prod&lang=css"
import style1 from "./records.vue?vue&type=style&index=1&id=5cd426b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd426b3",
  null
  
)

export default component.exports